/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react';
import { colors } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ChatIcon from '@mui/icons-material/ChatOutlined';
import CodeIcon from '@mui/icons-material/Code';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import FolderIcon from '@mui/icons-material/FolderOutlined';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LockOpenIcon from '@mui/icons-material/LockOpenOutlined';
import MailIcon from '@mui/icons-material/MailOutlined';
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import PeopleIcon from '@mui/icons-material/PeopleOutlined';
import PersonIcon from '@mui/icons-material/PersonOutlined';
import ReceiptIcon from '@mui/icons-material/ReceiptOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import BuildIcon from '@mui/icons-material/Build';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import ShowChartIcon from '@mui/icons-material/ShowChart';

import { Label } from 'components';

import config from '../../../../configuration/configuration.js';

export default [
	{
		title: '',
		pages: [
			{
				title: 'Home',
				href: '/home',
				icon: HomeIcon,
				// roles: ['Administrator', ...]
				// projects: ['Operations'],
			},
		],
	},
	{
		title: 'Menu',
		pages: [
			{
				title: 'Tracking',
				href: '/tracking',
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Operations'],
				icon: ListAltIcon,
				children: [
					{
						title: 'Commissioning Plan',
						href: '/tracking/commissioningplan',
					},
					{
						title: 'Tracker',
						href: '/tracking/tracker',
					},
					{
						title: 'Work Order Status',
						href: '/tracking/workorderstatus',
					},
				],
			},
			{
				title: 'Planning',
				href: '/planning',
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Operations'],
				icon: SettingsInputAntennaIcon,
				children: [
					{
						title: 'Parameter Planning',
						href: '/planning/parameterplanning',
					},
				],
			},
			{
				title: 'Validation',
				href: '/validation',
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Operations'],
				icon: FactCheckOutlinedIcon,
				children: [
					{
						title: 'ANR Validation',
						href: '/validation/anrvalidation',
					},
					{
						title: 'ANR NBR Tracking',
						href: '/validation/anrnbrtracking',
					},
					{
						title: 'Cosite Health Check',
						href: '/validation/cositeHealthCheck',
					},
					{
						title: 'Cpich Validation',
						href: '/validation/cpichvalidation',
					},
					{
						title: 'Nbr Relations Validation',
						href: '/validation/nbrRelationsValidation',
					},
					{
						title: 'RanShare Validation',
						href: '/validation/ranshareNbrRelationsValidation',
					},
					{
						title: 'Health Checks',
						href: '/validation/healthChecks',
					},
				],
			},
			{
				title: 'Optimization',
				href: '/optimization',
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Operations'],
				icon: BuildIcon,
				children: [
					{
						title: 'Nbr Relations Optimization',
						href: '/optimization/nbrRelationsOptimization',
					},
					{
						title: 'E2E Nbr Relations',
						href: '/optimization/e2eNbrRelations',
					},
				],
			},
			{
				title: 'Monitoring',
				href: '/monitoring',
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Operations'],
				icon: MonitorHeartOutlinedIcon,
				children: [
					{
						title: 'Upload Logs',
						href: '/monitoring/uploadLogs',
					},
					{
						title: 'Fault Management',
						href: '/monitoring/faultManagement',
					},
					{
						title: 'Configuration Management',
						href: '/monitoring/configurationManagement',
					},
					{
						title: 'Overall Site Summary',
						href: '/monitoring/overallSiteSummary',
					},
					{
						title: 'Site Report',
						href: '/monitoring/siteReport',
					},
				],
			},
			{
				title: 'Network Performance Monitoring',
				href: '/NetworkPerformanceMonitoring',
				icon: ShowChartIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Ran'],
				children: [
					{
						title: 'Per site',
						href: '/NetworkPerformanceMonitoring',
						children: [
							{
								title: '2G',
								href: '/NetworkPerformanceMonitoring/2gOverview',
							},
							{
								title: '3G',
								href: '/NetworkPerformanceMonitoring/3gOverview',
							},
							{
								title: '4G',
								href: '/NetworkPerformanceMonitoring/4gOverview',
							},
							{
								title: 'VoLTE',
								href: '/NetworkPerformanceMonitoring/voLTEOverview',
							},
							{
								title: '5G',
								href: '/NetworkPerformanceMonitoring/5gOverview',
							}
						]
					},
					{
						title: 'Per Cluster',
						href: '/NetworkPerformanceMonitoring/Cluster',
						children: [
							{
								title: '2G',
								href: '/NetworkPerformanceMonitoring/Cluster/2G',
							},
							{
								title: '3G',
								href: '/NetworkPerformanceMonitoring/Cluster/3G',
							},
							{
								title: '4G',
								href: '/NetworkPerformanceMonitoring/Cluster/4G',
							},
							{
								title: 'VoLTE',
								href: '/NetworkPerformanceMonitoring/Cluster/voLTE',
							},
							{
								title: '5G',
								href: '/NetworkPerformanceMonitoring/Cluster/5G',
							}
						]
					},
					{
						title: 'Drive Tests',
						href: '/NetworkPerformanceMonitoring/Map',
					}
				]
			},
			{
				title: 'Activity Tracker',
				href: '/activityTracker',
				icon: ListAltIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Ran'],
				children: [
					{
						title: 'Tracker',
						href: '/activityTracker/tracker',
					}
				]
			},
			{
				title: 'Dashboards',
				href: '/dashboards',
				icon: DashboardIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Operations'],
				children: [
					{
						title: 'Rollout',
						href: '/dashboards/dashboardRollout',
					}
				],
			},
		],
	},
	{
		title: 'Management',
		pages: [
			{
				title: 'Manage',
				href: '/management',
				roles: ['Administrator', 'Manager'],
				icon: SupervisorAccountIcon,
				children: [
					{
						title: 'Operators',
						href: '/management/operators',
					},
					{
						title: 'Users',
						href: '/management/users',
					}
				],
			},
			{
				title: 'Hangfire',
				href: `${config.API_URL}hangfire?access_token={token}`,
				target: '_blank',
				roles: ['Administrator'],
				icon: DesktopMacIcon
			},
			{
				title: 'Settings',
				href: '/management/settings',
				icon: SettingsIcon
			},
		],
	},
];
